var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center full-height"},[_c('ant-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }